module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAALVBMVEUAAAD///////////////////////////////////////////////////////+hSKubAAAAD3RSTlMAgHhAEHAgUGIYODAoCEjvfoZXAAAA1UlEQVQoz2MgA7A4YBFkNsAiOFESU4wzUBRT/yFBQR10MT5BIDBAs7oRJIhmwCJBMBBGFvMQhIIWhBiXIkxQaANc8CGIj2YAuyASKEAoRABxqKcRIgjHbkQVFAMLBqIKSoDE2ATRQALCSARYAHMQiqOIFnwA8ji6IMj7vOiC4EAFhi+mP52gjoZ6QgUsyAPhWHRB6AOQEEkFsbUv6m4C0WGwWDMVFFS+sFGKpRREw4N+WiYwXEQvMExLQUtKIFejg4PAkMRISorAqJyAJpgEslmHgc4AAMh+L7nHrFRxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/new/game/game-tab4.png
// module id = 57jg
// module chunks = 1